// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_5480be8"};